import { Button } from "@/components/ui/button";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useDispatch } from "react-redux";
import {
    initializeJourney,
} from "@/features/journey/journeySlice";
import { UnitGroup } from "@/types";
import { Step } from "@/types/enums";
import { getSteps } from "@/hooks/useSteps";

interface SelectButtonProps {
    unitGroup: UnitGroup;
    selectedPromo: number;
    onClick?: () => void;
    label?: string;
    dataState?: "open" | "closed";
    ariaControls?: string;
}
export const SelectButton = ({
    unitGroup,
    selectedPromo,
    onClick,
    label: labelOverride,
    dataState,
    ariaControls,
}: SelectButtonProps) => {
    const dispatch = useDispatch();
    const displayOptions = useDisplayOptionContext();
    const handleSelectEvent = () => {
        if (onClick) {
            onClick();
            return;
        }

        // If there are multiple subgroups, go to VBP step; otherwise, go to rent-reserve-quote step
        const hasMultipleSubGroups =
            Array.isArray(unitGroup.sub_groups) &&
            unitGroup.sub_groups.length > 1;

        const step = hasMultipleSubGroups ? Step.VBP : Step.RENT_RESERVE_QUOTE;

        const subGroupCount = unitGroup.sub_groups?.length ?? 0;
        const steps = getSteps(subGroupCount, displayOptions.buttonLayout);

        dispatch(
            initializeJourney({
                unitId: unitGroup.representative_unit.id,
                unitGroup,
                selectedPromo,
                stepList: steps,
                step,
            }),
        );
    };

    const label =
        labelOverride ?? displayOptions.language?.action?.selectButton ?? "Select";
    const expandedClass = dataState === "open" ? " expanded" : "";

    return (
        <Button
            variant="default"
            data-testid="selectButton"
            data-state={dataState}
            onClick={handleSelectEvent}
            type="button"
            aria-label={label}
            aria-expanded={dataState === "open" ? true : undefined}
            aria-controls={ariaControls}
            className={`select-btn${expandedClass}`}
        >
            {label}
        </Button>
    );
};

SelectButton.displayName = "SelectButton";
